import { Box, makeStyles } from '@material-ui/core';
import { CheckCircleOutline } from '@material-ui/icons';
import React from 'react'
import ProgressActivityIcon from './ProgressActivityIcon';

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    padding: theme.spacing(2),
    borderRadius: 8,
    background: '#F1F1F1',
    height: 60,
  },
  title: {
    fontSize: 16,
    lineHeight: '26px',
    color: 'rgba(26, 26, 26, 0.87)',
    letterSpacing: 0.3,
  },
  token: {
    color: 'rgba(26, 26, 26, 0.87)',
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '26px',
    letterSpacing: '2px'
  },
  subtitle: {
    color: 'rgba(26, 26, 26, 0.87)',
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '26px',
    letterSpacing: 0.3,
  },
  checkCircleColor: {
    color: '#3FAF3B'
  }
}));

export const InfoCardSection = (props) => {
  const { title, token = undefined, isLoading = false } = props;

  const classes = useStyles();
  return (
    <Box className={classes.content}>
      {isLoading ? <ProgressActivityIcon /> : <CheckCircleOutline className={classes.checkCircleColor} />}
      <span className={classes.title}>{title} {token && <span className={classes.token}>{token}</span>}</span>
    </Box>
  )
}
